import { Pagination } from '@pmi/dsm-react';
import './peopleCardList.scss';
import usePermissions from '../../../../shared/hooks/usePermissions';
import PERMISSIONS from '../../../../shared/permissions';
import { AgreementApiModel } from '../../../../shared/models/DealModel';

interface IPaginationProps {
  totalPages?: number;
  disabled?: boolean;
  size?: number;
  theme?: string;
  page?: number;
  pageSize?: number;
  onPageChange?: (pageNumber: number) => void;
  showPagination: boolean;
}

export interface PeopleCardListItemProperty<T, A> {
  item: T;
  actions: A | null;
}

export interface PeopleCardListProperty<T> {
  cardTemplate: (
    item: T,
    isInternalAdmin: boolean,
    accessibleDeals: AgreementApiModel[],
  ) => any;
  items: T[];
  className?: string;
  paginationProps?: IPaginationProps | null;
  loading?: boolean;
  accessibleDeals?: AgreementApiModel[];
}

export default function PeopleCardList<T>({
  cardTemplate,
  items = [],
  className = '',
  paginationProps = null,
  loading = false,
  accessibleDeals = [],
}: PeopleCardListProperty<T>) {
  const { hasAccess, isLoading: isAccessLoading } = usePermissions();
  const {
    totalPages = 10,
    page = 1,
    pageSize = 10,
    showPagination = true,
    onPageChange,
  } = paginationProps;

  const onPageChangeDsmCompatible = (e: unknown, pageNumber: number) =>
    onPageChange(pageNumber);

  const renderItems = () => (
    <>
      {items?.length > 0 &&
        items.map((item: T, index: number) => (
          <div key={`card-item-${index.toString()}`}>
            {cardTemplate(
              item,
              hasAccess({ permissions: [PERMISSIONS.ManageElevatedAdmins] }),
              accessibleDeals,
            )}
          </div>
        ))}
      {showPagination && (
        <div className="cardListPagination">
          <Pagination
            data-testid="test-pagination"
            className="d-block"
            totalPages={totalPages}
            showPageSizes={false}
            disabled={false}
            pageSizes={[]}
            onChange={onPageChangeDsmCompatible}
            onPageSizeChange={() => null}
            currentPage={page}
            pageSize={pageSize}
          />
        </div>
      )}
    </>
  );

  return (
    <div className={`__PeopleCardList ${className}`}>
      {(loading || isAccessLoading) && <p>Loading...</p>}
      {!loading && !isAccessLoading && items.length > 0 && renderItems()}
    </div>
  );
}
